import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private _session = signal<any>(null);
  session = this._session.asReadonly();

  user = computed<any>(() => this._session()?.user || null);
  appSubscription = computed<any>(() => this._session()?.appSubscription || null);
  appSubscriptions = computed<any>(() => this._session()?.appSubscriptions || []);
  allowedCustomerAccounts = computed<any>(() => {
    return (this._session()?.permissions || []).filter((o: any) => o.type === 'customerAccounts' && o.value).map((o: any) => o.value)
  });

  setSession(session: any): void {
    this._session.set(session);
  }

  clearSession(): void {
    this._session.set(null);
  }
}
